import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=2b50d312&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/menu.scss?vue&type=style&index=0&id=2b50d312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50d312",
  null
  
)

export default component.exports